<div class="content p-24">
    <div class="h1" *ngIf="isAddMode">
        New operator
    </div>
    <div class="h1" *ngIf="!isAddMode">
        Edit operator data
    </div>
    <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
        <form class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column" fxLayoutAlign="start"
              fxFlex="1 0 auto" name="form" [formGroup]="form" (ngSubmit)="onSubmit()">

            <div class="h2 mb-24">Operator data</div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                    <mat-label>Company name</mat-label>
                    <input matInput formControlName="name" required>
                    <mat-icon matSuffix class="secondary-text">domain</mat-icon>
                    <mat-error>Company name is required!</mat-error>
                </mat-form-field>

            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                <mat-form-field appearance="outline" fxFlex="33" class="pr-4">
                    <mat-label>VAT ID</mat-label>
                    <input matInput formControlName="vatId">
                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="33" class="pl-4">
                    <mat-label>Phone</mat-label>
                    <input matInput formControlName="phone">
                    <mat-icon matSuffix class="secondary-text">phone_iphone</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="34" class="pl-4">
                    <mat-label>E-mail</mat-label>
                    <input matInput formControlName="email">
                    <mat-icon matSuffix class="secondary-text">email</mat-icon>
                </mat-form-field>

            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                    <mat-label>Street</mat-label>
                    <input matInput formControlName="street">
                    <mat-icon matSuffix class="secondary-text">home</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="25" class="pl-4">
                    <mat-label>House number</mat-label>
                    <input matInput formControlName="houseNumber">
                    <mat-icon matSuffix class="secondary-text">home</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="25" class="pl-4">
                    <mat-label>Flat number</mat-label>
                    <input matInput formControlName="flatNumber">
                    <mat-icon matSuffix class="secondary-text">home</mat-icon>
                </mat-form-field>

            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                <mat-form-field appearance="outline" fxFlex="20" class="pr-4">
                    <mat-label>Post code</mat-label>
                    <input matInput formControlName="postCode">
                    <mat-icon matSuffix class="secondary-text">home</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="40" class="pl-4">
                    <mat-label>City</mat-label>
                    <input matInput formControlName="city">
                    <mat-icon matSuffix class="secondary-text">home</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="40">
                    <mat-label>Country</mat-label>
                    <mat-select formControlName="country" required>
                        <mat-option [value]="country.id" *ngFor="let country of countries">
                            {{country.name}}
                        </mat-option>
                    </mat-select>
                    <mat-icon matSuffix class="secondary-text">outlined_flag</mat-icon>
                    <mat-error>Country is required!</mat-error>
                </mat-form-field>

            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <button mat-raised-button type="submit" color="accent">
                        Save
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
